module.exports = __webpack_public_path__ + "img/1724248818148-IMG_1532.png.0eb90721.webp";